export const FO_PAY_CASH = 'cash';
export const FO_PAY_BANK = 'bank';

export const FO_PAY_CASH_LABEL = 'Наличные';
export const FO_PAY_BACK_LABEL = 'Расчетный счет';

export const FO_PAY_TYPES = [
  {
    value: FO_PAY_CASH,
    label: FO_PAY_CASH_LABEL,
  },
  {
    value: FO_PAY_BANK,
    label: FO_PAY_BACK_LABEL,
  },
];
